import { Component } from '@angular/core';
import { UtilityService } from '../../Model/utility/utility.service';
import { SessionService } from '../../Util/Session/session.service';
import { RouterOutlet, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { NgbDropdownModule, NgbCollapseModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CompanySelectionComponent } from '../CompanySelection/company-selection/company-selection.component';

@Component({
  selector: 'app-module-layout',
  standalone: true,
  imports: [CommonModule, NgbDropdownModule, NgbCollapseModule, RouterOutlet, RouterModule],
  templateUrl: './module-layout.component.html',
  styleUrl: './module-layout.component.scss'
})
export class ModuleLayoutComponent {
  user: any;
  constructor(
    private session: SessionService,
    private utility: UtilityService,
    private modalService: NgbModal,
  ) {
    this.user = this.session.GetUserDetails();
  }

  ngOnInit(): void {
    console.log(this.user.CompanyName)
  }

  Logout() {
    this.utility.LogOutDetails({ 'SelectType': 'LogOut', LoginName: this.user.LoginName }).subscribe({
      next: (response) => {
        if (response.Error_Code == "09")
          this.session.End();
      },
      complete: () => { },
      error: (error) => { },
    });
  }

  CompanySelection() {
    const modalRef = this.modalService.open(CompanySelectionComponent);
    modalRef.result.then(
      (result: any) => {
        if (result) {
          window.location.reload();
        }
      },
      () => { }
    );
  };

}
